export const GET_ITINERARY_SEGMENT = 'GET_ITINERARY_SEGMENT';
export const CLEAR_ITINERARY_SEGMENT = 'CLEAR_ITINERARY_SEGMENT';
export const FLAG_GETTING_ITINERARY_SEGMENT = 'FLAG_GETTING_ITINERARY_SEGMENT';

export const GET_ITINERARY_INCIDENTS = 'GET_ITINERARY_INCIDENTS';
export const CLEAR_ITINERARY_INCIDENTS = 'CLEAR_ITINERARY_INCIDENTS';
export const FLAG_GETTING_ITINERARY_INCIDENTS = 'FLAG_GETTING_ITINERARY_INCIDENTS';
